// 随机抽题， 随机组卷
<template>
    <div class="random-que yx-center" v-loading="flag.loading">
        <div>
            <span class="font-size16 font-medium c-333"
                >满足条件试题数量:</span
            ><span class="c-F33737 font-size22">{{ count }}</span>
        </div>
        <div class="xy-center jf-start item">
            <div class="name">所属分类:</div>
            <el-select v-model="queInfo.type" placeholder="请选择" clearable>
                <el-option
                    v-for="item in organClass"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                    <div
                        :style="{
                            paddingLeft: `${item.parentIds.length * 30}px`
                        }"
                    >
                        {{ item.label }}
                    </div>
                </el-option>
            </el-select>
        </div>
        <div class="xy-center jf-start item">
            <div class="name">试题难度:</div>
            <el-select
                v-model="queInfo.difficulty"
                placeholder="请选择"
                clearable
            >
                <el-option
                    v-for="item in difficultyData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                >
                </el-option>
            </el-select>
        </div>
        <div class="xy-center jf-start item">
            <div class="name">题型:</div>
            <el-select v-model="queInfo.queType" placeholder="请选择" clearable>
                <el-option
                    v-for="item in queTypeData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                >
                </el-option>
            </el-select>
        </div>
        <div class="xy-center jf-start item">
            <div class="name">用途:</div>
            <el-select v-model="queInfo.useFor" placeholder="请选择" clearable>
                <el-option
                    v-for="item in useForData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                >
                </el-option>
            </el-select>
        </div>

        <div class="xy-center jf-start item">
            <div class="name">选取试题数量:</div>
            <el-input v-model.number="selectQueCount"></el-input>
        </div>
    </div>
</template>

<script>
import { queSampling, paperSampling } from "@/api/manage.js";
import { GetOrganClassLit } from "@/api/questionPaper.js";
import { CommonPage } from "@/mixins/commonData";
import { random } from "lodash";
import { uuid } from "@/utils";
export default {
    mixins: [CommonPage],
    props: {
        nowChoose: {
            type: String
        }
    },
    data() {
        return {
            queInfo: {
                type: "",
                queType: "",
                difficulty: "",
                useFor: ""
            },
            count: 0,
            dataList: null,
            selectQueCount: "",
            organClass: [],
            submitDisable: false,
            flag: {
                loading: false
            },
            resultList: []
        };
    },

    mounted() {
        // 题型
        let queTypeDataboj = {
            name: "全部",
            value: ""
        }
        this.queTypeData.unshift(queTypeDataboj)

        let yongtuobj = {
            name: "全部",
            value: ""
        }
        this.useForData.unshift(yongtuobj)
        let obj = {
            name: "全部",
            value: ""
        }
        this.difficultyData.unshift(obj)
        this.fetchOrganClass();
    },
    watch: {
        queInfo: {
            handler(val) {
                this.fetchList();
                console.log("我在变化");
            },
            deep: true,
            immediate: true
        },
        selectQueCount(inputCount) {
            this.buildResult(inputCount)
        }
    },
    methods: {
        fetchOrganClass() {
            GetOrganClassLit().then((res) => {
                const data = res.data.data;
                // console.log("data:", data);
                let newData = [];
                const work = (vl, pIds) => {
                    for (let i = 0; i < vl.length; i++) {
                        newData.push({
                            label: vl[i].label,
                            value: vl[i].value,
                            parentIds: pIds
                        });
                        if (vl[i].children.length) {
                            work(vl[i].children, pIds.concat([vl[i].value]));
                        }
                    }
                };
                work(data, []);
                // console.log("newData:", newData);
                let all = {
                    label: "全部",
                    parentIds: [],
                    value: ""
                }
                newData.unshift(all)
                this.organClass = newData;
            });
        },
        async fetchList() {
            if (this.nowChoose === "随机抽题") {
                await this.flagPromise([
                    queSampling({
                        classId: this.queInfo.type,
                        subType: this.queInfo.queType,
                        hardLevel: this.queInfo.difficulty,
                        useType: this.queInfo.useFor
                    })
                ]).then(([res]) => {
                    this.count = res.data.count;
                    this.dataList = res.data.data;
                    // console.log("res:", res);
                });
            } else {
                await this.flagPromise([
                    paperSampling({
                        classId: this.queInfo.type,
                        subType: this.queInfo.queType,
                        hardLevel: this.queInfo.difficulty,
                        useType: this.queInfo.useFor
                    })
                ]).then(([res]) => {
                    this.count = res.data.count;
                    this.dataList = res.data.data;
                    // console.log("res:", res);
                });
            }
            this.buildResult(this.selectQueCount)
        },
        buildResult(inputCount) {
            if (inputCount === "" && parseInt(inputCount) === 0) {
                this.resultList = [];
                return;
            }
            if (parseInt(inputCount) > this.count) {
                this.$message.warning("已超出最大试题数");
            }
            this.submitDisable = inputCount > this.count;
            this.$emit("dis-btn", this.submitDisable);
            const copy = [...this.dataList];
            const result = [];
            for (let i = 0; i < inputCount; i++) {
                const index = random(0, copy.length - 1, false)
                result.push(...copy.splice(index, 1));
            }
            this.resultList = result;
        },
        // 获取随机规则
        getRule() {
            return {
                RoleClassId: this.queInfo.type,
                RoleSubjectTypeId: this.queInfo.queType,
                RoleHardlevel: this.queInfo.difficulty,
                RoleUseType: this.queInfo.useFor,
                RoleSubNum: this.selectQueCount,
                SubScore: 0,
                _uuid: uuid(5)
            }
        }
    }
};
</script>

<style lang="less" scoped>
.random-que::v-deep {
    .item {
        margin-top: 30px;
        margin-right: 50px;
        .name {
            white-space: nowrap;
            width: 7em;
            font-size: 16px;
            text-align: right;
            padding-right: 5px;
            box-sizing: border-box;
        }
    }
    .el-input {
        width: 210px;
        height: 34px;
        input {
            height: 34px;
            width: 210px;
            ::placeholder {
                font-size: 16px;
            }
        }
    }
}
</style>
